<template>
  <table class="c-table">
    <thead>
      <tr>
        <th width="170">お名前</th>
        <th>メールアドレス</th>
        <th>権限</th>
        <th width="170"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="isLoading">
        <td colspan="4" class="l-p-0 c-text--center">
          <LoadingChara variant="inline">
            <template slot="title">
              データ取得中
            </template>
          </LoadingChara>
        </td>
      </tr>
      <tr v-else-if="!items.length">
        <td colspan="4" class="l-p-0">
          <Error img="normal" variant="inline">
            <template slot="title">
              ユーザーがいません。
            </template>
          </Error>
        </td>
      </tr>
      <template v-else>
        <ListItemUser
          v-for="item in items"
          :key="item.userId"
          :item="item"
          @delete="deleteUser"
          @edit="editUser"
          @invite="inviteUser"
        />
      </template>
    </tbody>
  </table>
</template>

<script>
import Error from '@/components/Error';
import ListItemUser from '@/components/config/ListItemUser';
import LoadingChara from '@/components/LoadingChara';

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Error,
    ListItemUser,
    LoadingChara
  },
  methods: {
    deleteUser(item) {
      this.$emit('delete', item);
    },
    editUser(item) {
      this.$emit('edit', item);
    },
    inviteUser() {
      this.$emit('invite');
    }
  }
};
</script>
